module.exports = __webpack_public_path__ + "img/F5.2472dcf7.png";